import React from "react";
import { useResponsiveProp } from 'hooks/useBreakpoint';

export const Responsive = ({ Components = [], props, ...restProps }) => {
    const Component = useResponsiveProp(Components);
    if (Component === null) return null;
    return <Component {...restProps} />
}